<script>
import { mapGetters, mapMutations } from "vuex";

export default {
  data() {
    return {
      dark_mode: false,
      colors: [
        '#0077FF',
        '#cb4646',
        '#587991',
        '#464646',
        '#3a921d',
      ],
      themes: [
        {
          key: 'default',
          title: 'Default'
        },
        {
          key: 'fresh',
          title: 'Fresh'
        }
      ]
    }
  },
  mounted() {
    this.dark_mode = document.body.classList.contains('dark-mode') ? true : false
  },
  methods: {
    ...mapMutations(['changeUserColor', 'changeUserTheme']),
    darkMode() {
      if (!this.dark_mode) {
        document.body.classList.add('dark-mode')
        // document.documentElement.style.filter = 'invert(1)'
      } else {
        // document.documentElement.style.filter = 'none'
        document.body.classList.remove('dark-mode')
      }

    },
    changeColor(color) {
      this.changeUserColor(color)
      this.$socket.emit('IN_UserThemeChange', {
        color: color,
        name: this.activeTheme,
      })
    },
    changeTheme(theme) {
      this.changeUserTheme(theme)
      this.$socket.emit('IN_UserThemeChange', {
        color: this.activeColor,
        name: theme,
      })
    }
  },
  computed: {
    ...mapGetters(['getUserData']),
    activeTheme() {
      if (this.getUserData.theme) {
        if (this.getUserData.theme.name) {
          return this.getUserData.theme.name
        } else return 'default'
      } else return 'default'
    },
    activeColor() {
      if (this.getUserData.theme) {
        if (this.getUserData.theme.color) {
          return this.getUserData.theme.color
        } else return '#0077FF'
      } else return '#0077FF'
    }
  }
}
</script>

<template>
  <div>
    <div
        class="profile__content__upload"
        style="padding: 0 0 25px; margin: 45px 65px 0"
    >
      <ul class="themes_colors">
        <li
            v-for="color of colors" :key="color"
            :class="activeColor == color ? 'active' : ''"
            @click="changeColor(color)"
        >
          <div :style="'background-color: ' + color"></div>
        </li>
      </ul>
    </div>
    <div
        class="profile__content__background-item"
        style="padding: 40px 65px 0; overflow-y: auto; height: 400px"
    >
      <div
          v-for="theme of themes"
          :key="theme.key"
          @click="changeTheme(theme.key)"
          :class="
          activeTheme == theme.key
          ? 'active background-item__block'
          : 'background-item__block'
        "
      >
        <div style="background-color: #eee"></div>
        <span>{{ theme.title }}</span>
      </div>
    </div>
    <div style="display: flex; justify-content: flex-end; padding-right: 10px">
      <label>
<!--        Dark: <input type="checkbox" style="margin-left: 5px" @click="darkMode" v-model="dark_mode">-->
      </label>
    </div>
  </div>
</template>